// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FormValidationUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function execute(mobile, country) {
  switch (country.TAG | 0) {
    case /* UAE */0 :
        if (/^(?:\+971|00971|0)?(?:50|51|52|54|55|56|58|2|3|4|6|7|9)\d{7}$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    case /* India */1 :
        return FormValidationUtils$Catalyst.validateMobileNumber(mobile);
    case /* BD */2 :
        if (/(^(\+880|00880|0)?(1)[3456789](\d){8})$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    case /* TR */3 :
        if (/(^(\+90|0090|0)?(5)\d{9})$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    case /* MY */4 :
        if (/^(?:\+?60|0)?1[0-9]{8,9}$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    
  }
}

function executeWithoutCode(mobile, country) {
  switch (country.TAG | 0) {
    case /* UAE */0 :
        if (/^(?:50|51|52|54|55|56|58)\d{7}$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    case /* India */1 :
        return FormValidationUtils$Catalyst.validateMobileNumber(mobile);
    case /* BD */2 :
        if (/^(1)[3456789](\d){8}$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    case /* TR */3 :
        if (/(^(5)\d{9})$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    case /* MY */4 :
        if (/^1[0-9]{8,9}$/.test(mobile)) {
          return {
                  TAG: /* Ok */0,
                  _0: mobile
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Mobile Number"
                };
        }
    
  }
}

export {
  execute ,
  executeWithoutCode ,
  
}
/* No side effect */
